import React, { useContext } from 'react';
import { DataList, ModalContext, CustomModal } from 'commons-ui';
import type { BulkRequestListProps } from './types';
import { REQUEST_STATUS_MODAL_HEADER } from './constants';
import { VIEW_STATUS_ACTION_ID } from './actionIds';

const BulkRequestList: React.FC<BulkRequestListProps> = (props) => {
	const {
		defaults,
		fetchData,
		statusFetchData,
		columnConfigs,
		statusColumnConfigs,
		entity,
		statusEntity,
		getActionHandler,
		actions,
		forceUpdate,
		turnForceUpdateOff,
		onStatusClick
	} = props;

	const { setModalConfig } = useContext(ModalContext);

	const handleStatusClick = (requestId: string) => {
		if (onStatusClick) {
			onStatusClick(requestId);
			return;
		}

		setModalConfig({
			isOpen: true,
			header: REQUEST_STATUS_MODAL_HEADER,
			content: (
				<div style={{ width: '80vw', maxWidth: '90vw' }}>
					<DataList
						defaults={defaults}
						fetchData={statusFetchData(requestId)}
						columnConfigs={statusColumnConfigs}
						entity={statusEntity}
					/>
				</div>
			)
		});
	};

	const wrappedFetchData = async (params: any) => {
		const response = await fetchData(params);
		return response;
	};

	const wrappedActionHandler = getActionHandler
		? (...args: any[]) => {
				const handler = getActionHandler(...args);
				if (args[0]?.id === VIEW_STATUS_ACTION_ID) {
					return () => handleStatusClick(args[1]?.rowData?._id);
				}
				return handler;
		  }
		: undefined;

	return (
		<>
			<DataList
				defaults={defaults}
				fetchData={wrappedFetchData}
				columnConfigs={columnConfigs}
				getActionHandler={wrappedActionHandler}
				actions={actions}
				globalForceUpdate={forceUpdate}
				turnGlobalForceUpdateOff={turnForceUpdateOff}
				entity={entity}
			/>
			<CustomModal />
		</>
	);
};

export default BulkRequestList;
